(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offers"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth >= 1024) {
      const offerCards = document.querySelectorAll('.cs-card');
      const offerIcons = document.querySelectorAll('.cs-icon-container');
      const closeIcons = document.querySelectorAll('.current-offer-info__close-icon');
      const cardBodies = document.querySelectorAll('.cs-card-body');

      function showCard(parentCard) {
        const cardContainer = parentCard.querySelector('.current-offer-info__container');
        const icon = parentCard.querySelector('.cs-icon-container');
        const content = cardContainer.querySelector('.current-offer-info__content > p');

        if (cardContainer && icon) {
          cardContainer.classList.remove('hide');
          cardContainer.classList.add('visible');
          icon.classList.add('active');
          if (content) content.style.display = 'block';
        }
      }

      function hideCard(parentCard) {
        const cardContainer = parentCard.querySelector('.current-offer-info__container');
        const icon = parentCard.querySelector('.cs-icon-container');
        const content = cardContainer.querySelector('.current-offer-info__content > p');

        if (cardContainer && icon) {
          cardContainer.classList.remove('visible');
          cardContainer.classList.add('hide');
          icon.classList.remove('active');
          if (content) content.style.display = 'none';
        }
      }

      function hideAllCards() {
        offerCards.forEach(hideCard);
      }

      offerIcons.forEach(function (icon) {
        icon.addEventListener('click', function (event) {
          event.stopPropagation();
          const parentCard = this.closest('.cs-card');
          const isActive = icon.classList.contains('active');
          isActive ? hideCard(parentCard) : showCard(parentCard);
        });
      });

      closeIcons.forEach(function (closeIcon) {
        closeIcon.addEventListener('click', function (event) {
          event.stopPropagation();
          const parentCard = this.closest('.cs-card');
          hideCard(parentCard);
        });
      });

      cardBodies.forEach(function (body) {
        body.addEventListener('click', function (event) {
          event.stopPropagation();
          const parentCard = this.closest('.cs-card');
          hideCard(parentCard);
        });
      });

      document.addEventListener('click', function (event) {
        const clickedInsideCard = Array.from(offerCards).some((card) => card.contains(event.target));
        if (!clickedInsideCard) hideAllCards();
      });
    } else {
      var icons = document.querySelectorAll('.cs-icon-container');
      icons.forEach(function (icon, index) {
        icon.addEventListener('click', function () {
          document.querySelectorAll('.cs-card-info-active').forEach((i) => {
            if (i != icon) i.classList.remove('cs-card-info-active');
          });

          const card = icon.querySelector('.cs-card-info');
          const iconRect = icon.getBoundingClientRect();
          const cardRect = card.getBoundingClientRect();
          icon.classList.add('cs-card-info-active');
        });
      });

      document.addEventListener('click', function (e) {
        if (e.target.classList.contains('cs-icon-right')) {
          e.target.closest('.cs-icon-container').classList.remove('cs-card-info-active');
          return;
        }

        icons.forEach(function (icon, index) {
          if (icon.classList.contains('cs-card-info-active') && (icon == e.target || !icon.contains(e.target))) {
            return icon.classList.remove('cs-card-info-active');
          }
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
